import React, { forwardRef } from 'react';

import type { CheckboxProps, TouchRippleActions } from '@mui/material';
import { Checkbox } from '@mui/material';
import clsx from 'clsx';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  checkboxRoot: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  checked: {},
  colorPrimary: {
    '&.Mui-checked': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
  colorSecondary: {
    '&.Mui-checked': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
  },
}));

interface AlineCheckboxProps extends Omit<CheckboxProps, 'icon' | 'checkedIcon' | 'slotProps'> {
  density?: 'standard' | 'compact';
  disableHoverBackground?: boolean;
  slotProps?: {
    htmlInput?: React.InputHTMLAttributes<HTMLInputElement>;
  };
  touchRippleRef?: React.Ref<TouchRippleActions> | undefined;
}

export const AlineCheckbox = forwardRef<HTMLButtonElement | null, AlineCheckboxProps>(
  function AlineCheckbox(props, ref) {
    const { classes } = useStyles();
    const {
      classes: checkboxClasses,
      color = 'primary',
      // Extract DataGrid-specific props that MUI Checkbox doesn't understand
      density,
      disableHoverBackground = true,
      slotProps,
      touchRippleRef,
      ...rest
    } = props;

    return (
      <Checkbox
        ref={ref}
        classes={{
          checked: clsx(disableHoverBackground && classes.checked),
          colorPrimary: clsx(disableHoverBackground && classes.colorPrimary),
          colorSecondary: clsx(disableHoverBackground && classes.colorSecondary),
          root: clsx(disableHoverBackground && classes.checkboxRoot),
          ...checkboxClasses,
        }}
        color={color}
        {...rest}
      />
    );
  }
);
